<template>
  <div v-if="!isWeChat" class="container py-3">
    <AppHeader/>
    <main>
      <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 mb-3 text-center">
        <div v-for="u in urls" :key="u.url" class="col">
          <div class="card mb-4 rounded-3 shadow-sm">
            <div class="card-header py-3">
              <h3 class="display-6 text-center">{{ u.name }}</h3>
            </div>
            <div class="card-body">
              <h3 class="card-title pricing-card-title"><small class="text-muted fw-light" @click="openNewWin(u.url)">{{
                  u.url
                }}</small></h3>
              <ul class="list-unstyled mt-3 mb-4"/>
              <button :class="['w-100','btn','btn-lg', {'btn-outline-primary':u.status.status}]" type="button"
                      @click="openNewWin(u.url)">{{
                  u.status.message
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <AppFooter/>
  </div>
  <NoWeChat v-if="isWeChat"/>
</template>

<script setup>
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

import {onMounted, ref} from 'vue';
import NoWeChat from "@/views/NoWeChat.vue";

const enableTest = ref(true);

const urls = ref([
  {
    "name": "站点12",
    "url": "https://2.moomo.eu.cc/",
    "status": {
      status: true,
      message: "打开"
    }
  },
  {
    "name": "站点22",
    "url": "https://2.mvmo.cc.cd/",
    "status": {
      status: true,
      message: "打开"
    }
  }, {
    "name": "站点32",
    "url": "https://2.mvmo.ccwu.cc/",
    "status": {
      status: true,
      message: "打开"
    }
  }, {
    "name": "站点42",
    "url": "https://2.mvmo.eu.cc/",
    "status": {
      status: true,
      message: "打开"
    }
  }
  , {
    "name": "站点52",
    "url": "https://m8u1.homew.top/",
    "status": {
      status: true,
      message: "打开"
    }
  }
  , {
    "name": "站点62",
    "url": "https://m8u2.homew.top/",
    "status": {
      status: true,
      message: "打开"
    }
  }
  , {
    "name": "站点62",
    "url": "http://103.115.57.245/",
    "status": {
      status: true,
      message: "打开"
    }
  }
]);

onMounted(() => {
  if (enableTest.value) {
    const protocol = window.location.protocol;
    for (const u of urls.value) {
      if (u.url.toLowerCase().startsWith(protocol)) {
        sync_check(u);
      }
    }
  }
})

async function sync_check(u) {
  let url = u.url;
  if (!url.endsWith("/")) {
    url += "/"
  }

  url += "board/logo.svg"

  u.status = await checkUrlWithImgTag(url);
}

async function checkUrlWithImgTag(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = url;
    img.timeout = 5000;

    // 加载成功（说明网址可访问）
    img.onload = () => resolve({status: true, message: '网址可访问'});
    // 加载失败（可能不可访问或不是图片资源）
    img.onerror = () => resolve({status: false, message: '访问失败'});
    // 超时
    img.ontimeout = () => resolve({status: false, message: '访问超时'});
  });
}

function openNewWin(url) {
  window.open(url, '_blank');
}

/**
 * 是否微信浏览器打开
 * @type {boolean}
 */
const isWeChat = (() => {
  const ua = navigator.userAgent.toLowerCase();
  return (
      /micromessenger/.test(ua) ||
      /windowswechat/.test(ua) ||  // PC端微信
      /wxwork/.test(ua)           // 企业微信
  );
})();

</script>

<script type="text/javascript">
window.$crisp = [];
window.CRISP_WEBSITE_ID = "66506336-ab53-42b0-9151-c19c71e04fd4";
(function () {
  let d = window.document;
  let s = d.createElement("script");
  s.src = "https://client.crisp.chat/l.js";
  s.async = 1;
  d.getElementsByTagName("head")[0].appendChild(s);
})();
</script>